module.exports = __webpack_public_path__ + "static/GetStarted-6-34aeeb15e3f717b8a0fc4798153deb10.jpg";